module.exports = __webpack_public_path__ + "toBride2-we-r-g.4452d701.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-r-g.jpg
// module id = GenI
// module chunks = 0